import { PanelType } from '../../hooks/date';
import { withSimpleDate } from '../../units/date/hoc/withSimpleDate';
export var MonthPanel = withSimpleDate('panel', PanelType.MONTH);